import styled from "@emotion/styled";

export const Input = styled.input`
  color: var(--colors-neutral-2);
  border: solid 1px var(--colors-neutral-3);
  border-radius: var(--radii-0);
  font-family: monospace;
  padding: var(--space-2) var(--space-3);
`;
